(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-login"]) return;
  try {
     

document.addEventListener('DOMContentLoaded', function() {
// Get return_url from current URL
const urlParams = new URLSearchParams(window.location.search);
const returnUrl = urlParams.get('return_url');

if (returnUrl) {
// Update all account-related links to preserve return_url
const accountLinks = document.querySelectorAll('a[href*="/account/"]');
accountLinks.forEach(link => {
const url = new URL(link.href, window.location.origin);
if (!url.searchParams.has('return_url')) {
url.searchParams.set('return_url', returnUrl);
link.href = url.toString();
}
});
}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    

// Add this script to your registration page template
document.addEventListener('DOMContentLoaded', function() {
// Get the return_url parameter from the current page URL
const urlParams = new URLSearchParams(window.location.search);
const returnUrl = urlParams.get('return_url');

if (returnUrl) {
// Find the hidden return_to field that Shopify automatically creates
const returnToField = document.querySelector('input[name="return_to"]');

if (returnToField) {
// Extract just the path from the full URL
const decodedUrl = decodeURIComponent(returnUrl);
const urlObject = new URL(decodedUrl);
const pathOnly = urlObject.pathname; // This gets just "/products/casio-vintage-series-digital-grey-dial-watch"

// Replace the default /cart value with our custom return path
returnToField.value = pathOnly;
console.log('Updated return_to field to:', pathOnly);
}

// Optional: Also update the login link to preserve the return URL
const loginLink = document.querySelector('a[href*="account/login"]');
if (loginLink) {
const currentHref = loginLink.getAttribute('href');
const separator = currentHref.includes('?') ? '&' : '?';
loginLink.setAttribute('href', currentHref + separator + 'return_url=' + encodeURIComponent(returnUrl));
}
}
});


  } catch(e) { console.error(e); }
})();
})();
